/*globals ___browserSync___ */

import HTML2PDF from "@rmlibrary/html-pdf";

export function generatePDF(el, isPreview) {
    if (!el) el = document.getElementById("pdf-report");
    let title = el.getAttribute("data-title");
    const pdf = HTML2PDF.generate(el, { selectorPrefix: "rm-html-pdf " });
    pdf.doc.a11yMetadata(title);
    if (isPreview) {
        return pdf.doc.output("bloburi");
    }
    if (title.indexOf(".pdf") === -1) {
        title += ".pdf";
    }
    pdf.doc.save(title);
}

export function previewPDF(el) {
    const blobUrl = generatePDF(el, true);
    let iframe = document.getElementById("pdf-frame");
    if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.id = "pdf-frame";
        iframe.setAttribute("style", "position:fixed;top:0;left:0;width:100%;height:100%;border:0;z-index:99999;");
        document.body.appendChild(iframe);
        document.body.style.overflow = "hidden";
    }
    window.pdfFrame = iframe;
    iframe.src = blobUrl;
}

export function setupPreview(el) {
    setTimeout(() => {
        if (window.___browserSync___) {
            const onevent = ___browserSync___.socket.onevent;
            ___browserSync___.socket.onevent = function (e) {
                if (e.data[0] === "file:reload" && e.data[1].basename === "main.css") {
                    window.location.reload();
                }
                return onevent.call(this, e);
            };
        }
    }, 1500);
    previewPDF(el);
}
